/**
 * 리스트 조회 context
 */

import { Interval, afterDay } from "components/utils/comm";
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

export type initialFilterStateProps = {
  rmNo: string;
  rmOlkCd: string;
  rmTypCd: string;
  rmOpNm: string;
  rmResvNo: string;
  promCd: string;
  promNm: string;
  maxPerCtMax: string;
  maxPerCtMin: string;
  resvMemFstnm: string;
  resvMemMobNo: string;
  resvCstFstnm: string;
  resvCstMblNo: string;
  lodChlCd: string;
  sellSDt?: string;
  sellEDt?: string;
  resvSDt?: string;
  resvEDt?: string;
  sDt: string;
  eDt: string;
  dateTyp: "sell" | "resv" | "rmCnlResv";
};
interface ResvFilterContextType {
  filters: initialFilterStateProps;
  // initialFilterState: initialFilterStateProps;
  onChange: (name: string, value: string) => void;
  onSelect: (name: string, value: string) => void;
  onPickDate: (dates: Array<string>) => void;
  onReset: () => void;
}

const ResvFilterContext = createContext<ResvFilterContextType | undefined>(
  undefined
);

interface ResvFilterProviderProps {
  children: ReactNode;
}

export const ResvFilterProvider = ({ children }: ResvFilterProviderProps) => {
  const { sDt, eDt } = afterDay(Interval);
  const initialFilterState: initialFilterStateProps = {
    rmNo: "",
    rmOlkCd: "",
    rmTypCd: "",
    rmOpNm: "",
    rmResvNo: "",
    promCd: "",
    promNm: "",
    maxPerCtMax: "",
    maxPerCtMin: "",
    lodChlCd: "",
    resvMemFstnm: "",
    resvMemMobNo: "",
    resvCstFstnm: "",
    resvCstMblNo: "",
    sDt: sDt,
    eDt: eDt,
    dateTyp: "sell",
  };

  const [filters, setFilters] =
    useState<initialFilterStateProps>(initialFilterState);

  const onChange = (name: string, value: string) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const onSelect = (name: string, value: string) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const onPickDate = (dates: Array<string>) => {
    setFilters({
      ...filters,
      sDt: dates[0],
      eDt: dates[1],
    });
  };

  const onReset = () => {
    setFilters(initialFilterState);
  };

  return (
    <ResvFilterContext.Provider
      value={{
        filters,
        onChange,
        onSelect,
        onPickDate,
        onReset,
      }}
    >
      {children}
    </ResvFilterContext.Provider>
  );
};

export const useResvFilterContext = (): ResvFilterContextType => {
  const context = useContext(ResvFilterContext);

  if (!context) {
    throw new Error(
      "useResvFilterContext는 ResvFilterProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};

// list Context 타입 정의
interface ResvListContextType {
  isSuccess: boolean;
  setIsSuccess: (isSuccess: boolean) => void;
  param: Partial<initialFilterStateProps> | undefined;
  setParam: Dispatch<
    SetStateAction<Partial<initialFilterStateProps> | undefined>
  >;
}

const ResvListContext = createContext<ResvListContextType | undefined>(
  undefined
);

interface ResvListProviderProps {
  children: ReactNode;
}

export const ResvListProvider = ({ children }: ResvListProviderProps) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [param, setParam] = useState<
    Partial<initialFilterStateProps> | undefined
  >(undefined);

  return (
    <ResvListContext.Provider
      value={{ isSuccess, setIsSuccess, param, setParam }}
    >
      {children}
    </ResvListContext.Provider>
  );
};

export const useResvListContext = (): ResvListContextType => {
  const context = useContext(ResvListContext);

  if (!context) {
    throw new Error(
      "useResvListContext RoomListProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};

// 취소정보 조회 모달창 Context

interface ResvCancelContextType {
  openResvCancelModal: boolean;
  setOpenResvCancelModal: Dispatch<SetStateAction<boolean>>;
}

const ResvCancelContext = createContext<ResvCancelContextType | undefined>(
  undefined
);

interface ResvCancelProviderProps {
  children: ReactNode;
}

export const ResvResvCancelProvider = ({
  children,
}: ResvCancelProviderProps) => {
  const [openResvCancelModal, setOpenResvCancelModal] = useState(false);

  return (
    <ResvCancelContext.Provider
      value={{ openResvCancelModal, setOpenResvCancelModal }}
    >
      {children}
    </ResvCancelContext.Provider>
  );
};
export const useResvCancelContext = (): ResvCancelContextType => {
  const context = useContext(ResvCancelContext);

  if (!context) {
    throw new Error(
      "useResvCancelContext RoomListProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};
